"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivateSpendingNotifyAdminType = exports.ActivateMessagingPostGiftAction = exports.ActivateCampaignExchangeOption = exports.ActivateCampaignClaimType = void 0;
var ActivateCampaignClaimType;
exports.ActivateCampaignClaimType = ActivateCampaignClaimType;

(function (ActivateCampaignClaimType) {
  ActivateCampaignClaimType["PreApproved"] = "pre-approved";
  ActivateCampaignClaimType["FreeClaim"] = "free-claim";
})(ActivateCampaignClaimType || (exports.ActivateCampaignClaimType = ActivateCampaignClaimType = {}));

var ActivateCampaignExchangeOption;
exports.ActivateCampaignExchangeOption = ActivateCampaignExchangeOption;

(function (ActivateCampaignExchangeOption) {
  ActivateCampaignExchangeOption["CampaignBudget"] = "campaign-budget";
  ActivateCampaignExchangeOption["AlyceMarketplace"] = "alyce-marketplace";
  ActivateCampaignExchangeOption["CustomMarketplace"] = "custom-marketplace";
  ActivateCampaignExchangeOption["NoExchange"] = "no-exchange";
  ActivateCampaignExchangeOption["AcceptOnly"] = "accept-only";
})(ActivateCampaignExchangeOption || (exports.ActivateCampaignExchangeOption = ActivateCampaignExchangeOption = {}));

var ActivateMessagingPostGiftAction;
exports.ActivateMessagingPostGiftAction = ActivateMessagingPostGiftAction;

(function (ActivateMessagingPostGiftAction) {
  ActivateMessagingPostGiftAction["NoCta"] = "no-cta";
  ActivateMessagingPostGiftAction["Redirect"] = "redirect";
})(ActivateMessagingPostGiftAction || (exports.ActivateMessagingPostGiftAction = ActivateMessagingPostGiftAction = {}));

var ActivateSpendingNotifyAdminType;
exports.ActivateSpendingNotifyAdminType = ActivateSpendingNotifyAdminType;

(function (ActivateSpendingNotifyAdminType) {
  ActivateSpendingNotifyAdminType["EveryUsed"] = "every_used";
  ActivateSpendingNotifyAdminType["OnceUsed"] = "once_used";
  ActivateSpendingNotifyAdminType["OnceRemaining"] = "once_remaining";
})(ActivateSpendingNotifyAdminType || (exports.ActivateSpendingNotifyAdminType = ActivateSpendingNotifyAdminType = {}));